<template>
  <div class="footer_wrapper">
    <img style="width:100%" src="../assets/img2/foot_head.png" />
    <div>
      <div>
        <div>
          <div>关于企业</div>
          <div>
            <div
              class="pointer"
              @click="goUrl('/aboutus', 'inner', 'corporation')"
            >
              企业介绍
            </div>
            <div class="pointer" @click="goUrl('/agent', 'inner', 'vehicles')">
              车联网业务场景
            </div>
            <div class="pointer" @click="goUrl('/agent', 'inner', 'parter')">
              合作代理
            </div>
          </div>
          <div>
            <img style="margin-right:10px" src="../assets/img2/footer_wx.png" />
            <img style="margin-right:10px" src="../assets/img2/footer_tk.png" />
            <img style="margin-right:10px" src="../assets/img2/footer_wb.png" />
            <img
              style="margin-right:10px"
              src="../assets/img2/footer_xhs.png"
            />
          </div>
        </div>
        <div>
          <div>友情链接</div>
          <div>
            <div
              class="pointer"
              @click="goUrl('http://www.cnlaunch.com/', 'outer')"
            >
              元征官网
            </div>
            <div
              class="pointer"
              @click="goUrl('https://info.x431.com/', 'outer')"
            >
              X431官网
            </div>
            <div
              class="pointer"
              @click="goUrl('http://www.10010.com/net5/051/', 'outer')"
            >
              中国联通
            </div>
            <div
              class="pointer"
              @click="goUrl('http://www.beimai.com/', 'outer')"
            >
              北迈
            </div>
          </div>
        </div>
        <div>
          <div>联系我们</div>
          <div>
            <div style="display:flex;">
              <img src="../assets/img2/foot_location.png" />
              <div>深圳市南山区粤海街道深圳湾科技生态园7栋B座705</div>
            </div>
            <div>
              <img src="../assets/img2/foot_phone.png" />
              <div>0755-26928428 (9:30-18:00）</div>
            </div>
            <div>
              <img src="../assets/img2/foot_email.png" />
              <div>service@mingruidata.com</div>
            </div>
          </div>
        </div>
        <div>
          <div class="qrcode">
            <div>
              <img src="../assets/img2/footer_gzh.png" />
              <div>微信公众号</div>
            </div>
            <div>
              <img src="../assets/img2/footer_taobao.png" />
              <div>官方旗舰店</div>
            </div>
          </div>

          <div class="search-box">
            <div
              style="position:relative;width:279px;height: 48px;margin:  0 auto;"
            >
              <img
                style="display:block;width:100%;height: 100%;"
                src="../assets/img2/footer_search.png"
              />
              <div
                style="display:flex;position:absolute;position: absolute;
    height: 100%;
    align-items: center;
    top: 0;
    justify-content:space-between;
    padding: 0px 10px;
    box-sizing: border-box;
    width: 100%;"
              >
                <div
                  style="font-size: 16px;
font-weight: 400;
color: #C5C5C5;"
                >
                  搜索支持
                </div>
                <div
                  style="font-size: 18px;
font-weight: 500;
color: #333333;"
                >
                  Go
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div>
          Copyright©2020 深圳市明睿数据科技有限公司 All Rights Reserved.
        </div>
        <div class="a-div">
          <span>
            <a
              class="item-beian introduction-bottom-item"
              href="https://beian.miit.gov.cn/"
              target="view_frame"
              >粤ICP备20014753号-2</a
            >
          </span>
          <span> | 经营许可证编号：粤B2-20261844</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Footer",
  methods: {
    goUrl(url, type, hashId) {
      if (this.$route.path == url) {
        if (hashId) {
          document.getElementById(hashId).scrollIntoView({ block: "center" });
        }
        return;
      }
      switch (type) {
        case "inner":
          if (hashId) {
            this.$router.push({
              path: url,
              query: { hashId: hashId, time: new Date().getTime() },
            });
          } else {
            this.$router.push({ path: url });
          }
          break;
        case "outer":
          window.open(url);
          break;
      }
    },
  },
};
</script>
<style lang="less" scoped>
div.footer_wrapper {
  position: relative;
  min-width: 1420px;
  margin: 0 auto;
  background-image: url("../assets/img2/footer_bg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  // background: linear-gradient(14deg, #00065b 0%, #1459a2 100%);
  > div:last-child {
    position: relative;
    width: 1400px;
    margin: 0 auto;
    > div:first-child {
      position: relative;
      display: flex;
      flex-flow: row nowrap;
      > div:nth-child(-n + 3) {
        flex: 1;
        > div:first-child {
          box-sizing: border-box;
          // border-bottom: 1px solid #e4e4e4;
          position: relative;
          padding-top: 72px;
          padding-bottom: 10px;
          font-size: 24px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          line-height: 32px;
          color: white;
          opacity: 1;
        }
        > div:first-child::after {
          position: absolute;
          bottom: 0px;
          left: 0px;
          background: #fed501;
          height: 2px;
          width: 40px;
          content: "";
        }
        > div:last-child {
          position: relative;
          margin-top: 30px;
          > div {
            position: relative;
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            line-height: 24px;
            color: white;
            opacity: 1;
          }
          div:first-child {
            img {
              width: 11px;
              height: 17px;
              margin-top: 4px;
              margin-right: 6px;
            }
          }
          div:last-child {
            img {
              width: 16px;
              height: 13px;
              margin-top: 6px;
              margin-right: 6px;
            }
          }
          div:nth-child(2) {
            img {
              width: 15px;
              height: 15px;
              margin-top: 8px;
              margin-right: 6px;
            }
          }
          div {
            display: flex;
            align-items: flex-start;
          }
          > div + div {
            margin-top: 16px;
          }
        }
        > div:nth-child(2) {
          position: relative;
          margin-top: 30px;
          > div {
            position: relative;
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            line-height: 24px;
            color: white;
            opacity: 1;
          }
          div:first-child {
            img {
              width: 11px;
              height: 17px;
              margin-top: 4px;
              margin-right: 15px;
            }
          }
          div:last-child {
            img {
              width: 16px;
              height: 13px;
              margin-top: 6px;
              margin-right: 15px;
            }
          }
          div:nth-child(2) {
            img {
              width: 15px;
              height: 15px;
              margin-top: 8px;
              margin-right: 15px;
            }
          }
          div {
            display: flex;
            align-items: flex-start;
          }
          > div + div {
            margin-top: 16px;
          }
        }
      }
      > div:last-child {
        margin-left: 120px;
        > div:first-child {
          box-sizing: border-box;
          position: relative;
          padding-top: 72px;
          padding-bottom: 10px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          line-height: 32px;
          color: white;
          opacity: 1;
        }
        div.search-box {
          margin: 0 auto;
          margin-top: 30px;
          text-align: center;
          position: relative;
        }
      }
    }
    > div:last-child {
      position: relative;
      margin-top: 60px;
      padding-bottom: 40px;
      text-align: center;
      font-size: 18px;
      font-weight: 400;
      line-height: 24px;
      color: white;
    }
  }
  .pointer {
    cursor: pointer;
  }
  .qrcode {
    display: flex;
    flex-flow: row nowrap;
    font-size: 22px;
    justify-content: center;
    > div:first-child {
      margin-right: 20px;
    }
    > div {
      display: flex;
      flex-flow: column nowrap;
      align-items: center;
      font-size: 18px;
      font-weight: 400;
      line-height: 22px;
      color: white;
      opacity: 1;
      div {
        margin-top: 10px;
      }
      > img :first-child {
        width: 118px;
        height: 118px;
        margin-bottom: 10px;
      }
      > img :last-child {
        width: 134px;
        height: 134px;
      }
    }
  }
}
.item-beian {
  display: block;
  color: #fff;
  text-decoration: none;
  cursor: pointer;
}
.a-div {
  display: flex;
  justify-content: center;
  align-items: center;
  > span:last-child {
    margin-left: 10px;
  }
}
</style>
